import { ReleaseMeteringApplyItemDto } from '../dtos/release-metering-apply-item.dto';

export class ReleaseMeteringApplyRequest {
  records!: ReleaseMeteringApplyItemDto[];
}
